import {
  BADGE_W,
  COLORS,
  FOOTER_H,
  HEADER_H,
  PAD,
  WIDTH,
  calcRowHeight,
  createCanvas,
  downloadCanvas,
  drawFooter,
  drawHeader,
  fill,
  fitText,
  loadLogo,
  roundRect,
  setFont,
  strokeBorder
} from './imageKit';

export type ShirtSummaryItem = {
  tamanho: string;
  quantidade: number;
};

type GenerateOptions = {
  itens: ShirtSummaryItem[];
  ano: string;
};

const HERO_H = 156;
const LIST_TOP = 62;
const LIST_BOTTOM = 20;

export const generateShirtSummaryImage = async ({ itens, ano }: GenerateOptions) => {
  const dados = itens.filter((item) => item.quantidade > 0);
  if (dados.length === 0) return;

  const total = dados.reduce((sum, item) => sum + item.quantidade, 0);
  const maior = dados.reduce((top, item) => (item.quantidade > top.quantidade ? item : top), dados[0]);
  const maxQuantidade = Math.max(1, maior.quantidade);

  const alturaFixa = HEADER_H + 32 + HERO_H + 24 + LIST_TOP + LIST_BOTTOM + 24 + FOOTER_H;
  const rowH = calcRowHeight(dados.length, alturaFixa);
  const listaH = LIST_TOP + dados.length * rowH + LIST_BOTTOM;
  const height = alturaFixa + dados.length * rowH;

  const logo = await loadLogo();
  const surface = createCanvas(height);
  if (!surface) return;
  const { canvas, ctx } = surface;

  drawHeader(ctx, logo, 'Resumo de Camisas por Tamanho', `Período ${ano}`);

  // Destaque do total
  const heroY = HEADER_H + 32;
  roundRect(ctx, PAD, heroY, WIDTH - PAD * 2, HERO_H, 12);
  fill(ctx, COLORS.cardBg);
  strokeBorder(ctx, COLORS.border);

  ctx.textAlign = 'center';
  ctx.fillStyle = COLORS.primary;
  setFont(ctx, 800, 66);
  ctx.fillText(String(total), WIDTH / 2, heroY + 78);
  ctx.fillStyle = COLORS.muted;
  setFont(ctx, 700, 14);
  ctx.fillText('CAMISAS NO TOTAL', WIDTH / 2, heroY + 108);
  ctx.fillStyle = COLORS.text;
  setFont(ctx, 600, 15);
  ctx.fillText(
    `${dados.length} tamanhos diferentes • mais pedido: ${maior.tamanho} (${maior.quantidade})`,
    WIDTH / 2,
    heroY + 136
  );
  ctx.textAlign = 'left';

  // Lista de tamanhos
  const listaY = heroY + HERO_H + 24;
  roundRect(ctx, PAD, listaY, WIDTH - PAD * 2, listaH, 12);
  fill(ctx, COLORS.cardBg);
  strokeBorder(ctx, COLORS.border);

  const x0 = PAD + 24;
  const innerW = WIDTH - PAD * 2 - 48;

  ctx.fillStyle = COLORS.muted;
  setFont(ctx, 700, 12);
  ctx.fillText('TAMANHO', x0, listaY + 34);
  ctx.textAlign = 'right';
  ctx.fillText('QUANTIDADE', x0 + innerW, listaY + 34);
  ctx.textAlign = 'left';

  ctx.strokeStyle = COLORS.border;
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(x0, listaY + 48);
  ctx.lineTo(x0 + innerW, listaY + 48);
  ctx.stroke();

  const trackX = x0 + BADGE_W + 20;
  const trackW = innerW - BADGE_W - 20 - 100;

  dados.forEach((item, index) => {
    const rowY = listaY + LIST_TOP + index * rowH;
    const center = rowY + rowH / 2;
    const destaque = item.tamanho === maior.tamanho;

    if (index % 2 === 0) {
      roundRect(ctx, PAD + 12, rowY + 3, WIDTH - PAD * 2 - 24, rowH - 6, 8);
      fill(ctx, COLORS.softBg);
    }

    roundRect(ctx, x0, center - 24, BADGE_W, 48, 10);
    fill(ctx, COLORS.badgeBg);
    const rotulo = fitText(ctx, item.tamanho, BADGE_W - 16, 800, 26, 11);
    ctx.fillStyle = COLORS.primaryDark;
    ctx.textAlign = 'center';
    ctx.fillText(rotulo, x0 + BADGE_W / 2, center + 9);
    ctx.textAlign = 'left';

    roundRect(ctx, trackX, center - 9, trackW, 18, 9);
    fill(ctx, COLORS.barTrack);
    const larguraBarra = Math.max(12, (item.quantidade / maxQuantidade) * trackW);
    roundRect(ctx, trackX, center - 9, larguraBarra, 18, 9);
    fill(ctx, destaque ? COLORS.primaryDark : COLORS.primary);

    ctx.fillStyle = COLORS.title;
    setFont(ctx, 800, 32);
    ctx.textAlign = 'right';
    ctx.fillText(String(item.quantidade), x0 + innerW, center + 11);
    ctx.textAlign = 'left';
  });

  drawFooter(ctx, listaY + listaH + 24, `${total} camisas • ${dados.length} tamanhos`);
  downloadCanvas(canvas, `resumo-camisas-${ano}.png`);
};
